import { useState, useEffect, useRef } from "react";
import { useTheme } from "../context/Themecontext";
import escudo from "../assets/img/escudo.png";
import User from './User';
import Departamento from './Departamento';
import Conteudo from './Conteudo';
import Formacao from './Formacao';
import FormacaoRead from './FormacaoRead';
import Dashboard from './Dashboard';
import Questionario from './Questionario';
import ResultadosQuizzesPage from './ResultadosQuizzesPage';
import GerarProvasPage from './GerarProvasPage';

// ── Navegação ──────────────────────────────────────────────────────────────
// Itens sem "children" são links directos.
// Itens com "children" abrem um submenu (ex.: Formações → Gestão / Formação).
const NAV_ITEMS = [
  {
    section: "Principal",
    items: [
      { id: "dashboard", label: "Dashboard", icon: "grid" },
    ],
  },
  {
    section: "Gestão",
    items: [
      { id: "conteudos", label: "Conteúdo", icon: "pos" },
      {
        id: "formacoes-group",
        label: "Formações",
        icon: "invoice",
        children: [
          { id: "formacoes", label: "Gestão" },
          { id: "leitura", label: "Formação" },
        ],
      },
      { id: "questionarios", label: "Questionários", icon: "hr" ,

          children: [
          { id: "hra", label: "Gestão" },
          { id: "hr", label: "Questionários" },
        ],


      },
      { id: "departamentos", label: "Departamentos", icon: "clock" },
      { id: "respostas", label: "Respostas", icon: "clock" },
    ],
  },
  {
    section: "Sistema",
    items: [
      { id: "users", label: "Utilizadores", icon: "users" },
    ],
  },
];

const NOTIFICATIONS = [
  { id: 1, text: "Nova fatura criada por João Silva", time: "há 5 min", unread: true },
  { id: 2, text: "Relatório mensal disponível", time: "há 1h", unread: true },
  { id: 3, text: "Actualização do sistema concluída", time: "há 3h", unread: false },
];

// ── Layout Principal ───────────────────────────────────────────────────────
export default function AppLayout({ children }) {
  const { dark, toggleDark } = useTheme();          // ← tema global persistido

  const [collapsed, setCollapsed] = useState(false);
  const [activeItem, setActiveItem] = useState("dashboard");
  const [expandedNav, setExpandedNav] = useState("formacoes-group"); // submenu aberto por omissão
  const [showNotif, setShowNotif] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const notifRef = useRef(null);
  const profileRef = useRef(null);
  const [nome, setNome] = useState('');
  const [perfil, setPrfil] = useState('');

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;

    setNome(user.nome);
    setPrfil(user.perfil);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setShowNotif(false);
      if (profileRef.current && !profileRef.current.contains(e.target)) setShowProfile(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const unreadCount = NOTIFICATIONS.filter(n => n.unread).length;

  // ── Tokens de cor derivados do modo ─────────────────────────────────────
  const t = dark ? {
    bg: "#020b1a",
    bgSidebar: "rgba(3, 14, 35, 0.95)",
    bgTopbar: "rgba(3, 14, 35, 0.92)",
    bgCard: "rgba(8, 22, 50, 0.8)",
    bgHover: "rgba(0, 144, 231, 0.1)",
    bgActive: "rgba(0, 144, 231, 0.18)",
    bgDropdown: "#071428",
    border: "rgba(0, 174, 255, 0.1)",
    borderActive: "rgba(0, 174, 255, 0.35)",
    textPrimary: "#e8f4ff",
    textSecondary: "rgba(160, 210, 255, 0.6)",
    textMuted: "rgba(160, 210, 255, 0.38)",
    textActive: "#00c6ff",
    sectionLabel: "rgba(0, 174, 255, 0.4)",
    scrollbar: "rgba(0, 174, 255, 0.2)",
    shadow: "0 8px 32px rgba(0,0,0,0.6)",
    sidebarShadow: "4px 0 24px rgba(0,0,0,0.4)",
    topbarShadow: "0 2px 20px rgba(0,0,0,0.3)",
    glass: true,
  } : {
    bg: "#f0f4fb",
    bgSidebar: "#ffffff",
    bgTopbar: "rgba(255,255,255,0.96)",
    bgCard: "#ffffff",
    bgHover: "rgba(0, 144, 231, 0.06)",
    bgActive: "rgba(0, 144, 231, 0.1)",
    bgDropdown: "#ffffff",
    border: "#e2eaf0",
    borderActive: "rgba(0, 144, 231, 0.4)",
    textPrimary: "#0d1b2a",
    textSecondary: "#4a6478",
    textMuted: "#94a3b8",
    textActive: "#0057ff",
    sectionLabel: "#94a3b8",
    scrollbar: "#d0e4f0",
    shadow: "0 4px 24px rgba(0,68,238,0.08)",
    sidebarShadow: "2px 0 16px rgba(0,68,238,0.06)",
    topbarShadow: "0 2px 12px rgba(0,68,238,0.06)",
    glass: false,
  };

  const SW = collapsed ? "72px" : "240px";
  const TH = "64px";

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  }

  // Achata items + children para localizar o label activo
  const allLeaves = NAV_ITEMS.flatMap(s => s.items.flatMap(i => i.children ? i.children : [i]));
  const activeLabel = allLeaves.find(i => i.id === activeItem)?.label ?? "Dashboard";

  const renderContent = () => {
    switch (activeItem) {
      case "users":
        return <User />;

      case "departamentos":
        return <Departamento />

      case "conteudos":
        return <Conteudo />

      case "formacoes":
        return <Formacao />

      case "leitura":
        return <FormacaoRead />

      case "dashboard":
        return <Dashboard />

        case "hr":
          return <Questionario/>
               
          case "hra":
          return <GerarProvasPage/>

                case "respostas":
        return <ResultadosQuizzesPage />

      default:
        return <DemoContent t={t} dark={dark} label={activeLabel} />;
    }
  };

  // Abre/fecha um submenu; se o item não tiver filhos, navega directamente
  const handleNavClick = (item) => {
    if (item.children) {
      setExpandedNav(prev => (prev === item.id ? null : item.id));
      return;
    }
    setActiveItem(item.id);
    setMobileOpen(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        body {
          font-family: 'Inter', sans-serif;
          background: ${t.bg};
          color: ${t.textPrimary};
          min-height: 100vh;
          transition: background 0.35s ease, color 0.35s ease;
        }

        /* ══════════════════════════════════════
           SIDEBAR
        ══════════════════════════════════════ */
        .al-sidebar {
          position: fixed;
          top: 0; left: 0; bottom: 0;
          width: ${SW};
          background: ${t.bgSidebar};
          border-right: 1px solid ${t.border};
          box-shadow: ${t.sidebarShadow};
          display: flex;
          flex-direction: column;
          z-index: 200;
          overflow: hidden;
          transition:
            width       0.32s cubic-bezier(.22,1,.36,1),
            background  0.35s ease,
            border-color 0.35s ease,
            box-shadow  0.35s ease;
          ${t.glass ? "backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);" : ""}
        }

        ${dark ? `
        .al-sidebar::after {
          content: '';
          position: absolute;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,174,255,0.07) 0%, transparent 70%);
          bottom: 60px; left: -50px;
          pointer-events: none;
        }` : ""}

        /* Logo row */
        .al-logo-row {
          height: ${TH};
          display: flex;
          align-items: center;
          justify-content: ${collapsed ? "center" : "flex-start"};
          padding: 0 ${collapsed ? "0" : "18px"};
          gap: 10px;
          flex-shrink: 0;
          transition: padding 0.32s ease;
        }

        .al-logo-mark {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .al-logo-mark img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }

        .al-logo-text {
          font-size: 0.95rem;
          font-weight: 700;
          letter-spacing: 0.07em;
          text-transform: uppercase;
          background: linear-gradient(135deg, #00c6ff 0%, #0057ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          white-space: nowrap;
          flex: 1;
          opacity: ${collapsed ? 0 : 1};
          transition: opacity 0.2s ease;
          overflow: hidden;
        }

        .al-collapse-btn {
          width: 26px; height: 26px;
          border-radius: 7px;
          border: 1px solid ${t.border};
          background: ${t.bgHover};
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          color: ${t.textSecondary};
          flex-shrink: 0;
          transition: background 0.2s, color 0.2s, transform 0.32s;
          transform: rotate(${collapsed ? "180deg" : "0deg"});
        }
        .al-collapse-btn:hover { background: ${t.bgActive}; color: ${t.textActive}; }

        /* Nav */
        .al-nav {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 12px 0;
          scrollbar-width: thin;
          scrollbar-color: ${t.scrollbar} transparent;
        }
        .al-nav::-webkit-scrollbar { width: 3px; }
        .al-nav::-webkit-scrollbar-track { background: transparent; }
        .al-nav::-webkit-scrollbar-thumb { background: ${t.scrollbar}; border-radius: 99px; }

        .al-nav-section { margin-bottom: 4px; }

        .al-section-label {
          font-size: 0.6rem;
          font-weight: 700;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: ${t.sectionLabel};
          padding: 0 ${collapsed ? "0" : "20px"};
          margin: 16px 0 5px;
          display: flex;
          justify-content: ${collapsed ? "center" : "flex-start"};
          white-space: nowrap;
          overflow: hidden;
          opacity: ${collapsed ? 0 : 1};
          max-height: ${collapsed ? "0" : "30px"};
          transition: opacity 0.2s ease, max-height 0.25s ease;
        }

        .al-nav-item {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 0 ${collapsed ? "0" : "10px"};
          margin: 1px ${collapsed ? "10px" : "8px"};
          height: 40px;
          border-radius: 10px;
          cursor: pointer;
          color: ${t.textSecondary};
          font-size: 0.85rem;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          position: relative;
          justify-content: ${collapsed ? "center" : "flex-start"};
          border: 1px solid transparent;
          transition: background 0.18s, color 0.18s, border-color 0.18s;
          text-decoration: none;
          user-select: none;
        }
        .al-nav-item:hover {
          background: ${t.bgHover};
          color: ${t.textPrimary};
        }
        .al-nav-item.active {
          background: ${t.bgActive};
          color: ${t.textActive};
          border-color: ${t.borderActive};
          font-weight: 600;
        }
        .al-nav-item.active::before {
          content: '';
          position: absolute;
          left: -8px; top: 8px; bottom: 8px;
          width: 3px;
          border-radius: 0 3px 3px 0;
          background: linear-gradient(to bottom, #00aaff, #0044ee);
        }

        .al-nav-icon {
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
          width: 18px; height: 18px;
        }

        .al-nav-label {
          flex: 1;
          opacity: ${collapsed ? 0 : 1};
          transition: opacity 0.15s ease;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .al-nav-caret {
          display: ${collapsed ? "none" : "flex"};
          align-items: center; justify-content: center;
          color: ${t.textMuted};
          flex-shrink: 0;
          transition: transform 0.2s ease, color 0.18s;
        }
        .al-nav-caret.open { transform: rotate(90deg); color: ${t.textActive}; }

        /* Submenu */
        .al-nav-children {
          padding: 2px 0 4px;
        }
        .al-nav-child {
          display: flex;
          align-items: center;
          height: 34px;
          margin: 1px 8px 1px 34px;
          padding: 0 10px;
          border-radius: 8px;
          font-size: 0.8rem;
          font-weight: 500;
          color: ${t.textSecondary};
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative;
          transition: background 0.15s, color 0.15s;
        }
        .al-nav-child::before {
          content: '';
          position: absolute;
          left: -14px; top: 50%;
          width: 8px; height: 1px;
          background: ${t.border};
        }
        .al-nav-child:hover { background: ${t.bgHover}; color: ${t.textPrimary}; }
        .al-nav-child.active {
          background: ${t.bgActive};
          color: ${t.textActive};
          font-weight: 600;
        }

        /* Tooltip no modo colapsado */
        .al-nav-item[data-tip]:hover::after {
          content: attr(data-tip);
          position: absolute;
          left: calc(100% + 14px);
          top: 50%;
          transform: translateY(-50%);
          background: ${dark ? "#071428" : "#1a2b3c"};
          color: #fff;
          font-size: 0.74rem;
          font-weight: 500;
          padding: 5px 10px;
          border-radius: 7px;
          white-space: nowrap;
          pointer-events: none;
          z-index: 999;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          display: ${collapsed ? "block" : "none"};
        }

        /* Sidebar bottom */
        .al-sidebar-bottom {
          padding: 10px 8px 14px;
          border-top: 1px solid ${t.border};
          flex-shrink: 0;
        }

        .al-theme-row {
          display: flex;
          align-items: center;
          justify-content: ${collapsed ? "center" : "space-between"};
          gap: 10px;
          padding: ${collapsed ? "0" : "0 8px"};
          height: 40px;
          border-radius: 10px;
          cursor: pointer;
          color: ${t.textSecondary};
          font-size: 0.78rem;
          font-weight: 500;
          transition: background 0.18s, color 0.18s;
          user-select: none;
        }
        .al-theme-row:hover { background: ${t.bgHover}; color: ${t.textPrimary}; }

        .al-switch {
          width: 36px; height: 20px;
          border-radius: 99px;
          background: ${dark ? "linear-gradient(135deg,#00aaff,#0044ee)" : "#dde6f0"};
          position: relative;
          flex-shrink: 0;
          transition: background 0.3s;
          display: ${collapsed ? "none" : "block"};
        }
        .al-switch::after {
          content: '';
          position: absolute;
          width: 14px; height: 14px;
          border-radius: 50%;
          background: #fff;
          top: 3px;
          left: ${dark ? "19px" : "3px"};
          transition: left 0.25s cubic-bezier(.22,1,.36,1);
          box-shadow: 0 1px 4px rgba(0,0,0,0.25);
        }

        /* ══════════════════════════════════════
           TOPBAR
        ══════════════════════════════════════ */
        .al-topbar {
          position: fixed;
          top: 0;
          left: ${SW};
          right: 0;
          height: ${TH};
          background: ${t.bgTopbar};
          border-bottom: 1px solid ${t.border};
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          display: flex;
          align-items: center;
          padding: 0 22px;
          gap: 14px;
          z-index: 100;
          box-shadow: ${t.topbarShadow};
          transition:
            left        0.32s cubic-bezier(.22,1,.36,1),
            background  0.35s ease,
            border-color 0.35s ease;
        }

        .al-page-title-bar {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          min-width: 0;
        }
        .al-page-name {
          font-size: 0.92rem;
          font-weight: 700;
          color: ${t.textPrimary};
          letter-spacing: -0.01em;
          line-height: 1.2;
        }
        .al-breadcrumb {
          font-size: 0.72rem;
          color: ${t.textMuted};
          margin-top: 1px;
        }
        .al-breadcrumb span { color: ${t.textActive}; font-weight: 500; }

        .al-search {
          display: flex;
          align-items: center;
          gap: 9px;
          background: ${t.bgCard};
          border: 1px solid ${t.border};
          border-radius: 10px;
          padding: 0 13px;
          height: 37px;
          width: 200px;
          transition: border-color 0.2s, box-shadow 0.2s, width 0.3s ease;
          flex-shrink: 0;
        }
        .al-search:focus-within {
          border-color: #0090e7;
          box-shadow: 0 0 0 3px rgba(0,144,231,0.12);
          width: 260px;
        }
        .al-search input {
          background: none; border: none; outline: none;
          font-size: 0.8rem; color: ${t.textPrimary};
          font-family: 'Inter', sans-serif; width: 100%;
        }
        .al-search input::placeholder { color: ${t.textMuted}; }
        .al-search-icon { color: ${t.textMuted}; display: flex; flex-shrink: 0; }

        .al-actions {
          display: flex; align-items: center; gap: 6px; flex-shrink: 0;
        }

        .al-icon-btn {
          width: 37px; height: 37px;
          border-radius: 9px;
          border: 1px solid ${t.border};
          background: ${t.bgCard};
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          color: ${t.textSecondary};
          position: relative;
          transition: background 0.18s, color 0.18s, border-color 0.18s;
          flex-shrink: 0;
        }
        .al-icon-btn:hover {
          background: ${t.bgHover};
          color: ${t.textPrimary};
          border-color: ${t.borderActive};
        }

        .al-badge {
          position: absolute; top: 6px; right: 6px;
          width: 8px; height: 8px;
          border-radius: 50%;
          background: #ef4444;
          border: 2px solid ${t.bgTopbar};
          transition: border-color 0.35s ease;
        }

        .al-dropdown {
          position: absolute;
          top: calc(100% + 10px);
          right: 0;
          background: ${t.bgDropdown};
          border: 1px solid ${t.border};
          border-radius: 14px;
          box-shadow: ${t.shadow};
          z-index: 500;
          overflow: hidden;
          animation: alDropIn 0.22s cubic-bezier(.22,1,.36,1);
        }
        @keyframes alDropIn {
          from { opacity: 0; transform: translateY(-8px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }

        .al-drop-header {
          padding: 13px 16px 9px;
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: ${t.sectionLabel};
          border-bottom: 1px solid ${t.border};
        }

        .al-notif-item {
          display: flex; gap: 11px;
          padding: 11px 16px;
          border-bottom: 1px solid ${t.border};
          cursor: pointer; align-items: flex-start;
          transition: background 0.15s;
        }
        .al-notif-item:last-child { border-bottom: none; }
        .al-notif-item:hover { background: ${t.bgHover}; }

        .al-notif-dot {
          width: 7px; height: 7px; border-radius: 50%;
          background: #0090e7; margin-top: 5px; flex-shrink: 0;
          opacity: 0; transition: opacity 0.2s;
        }
        .al-notif-dot.unread { opacity: 1; }

        .al-notif-text { font-size: 0.79rem; color: ${t.textPrimary}; line-height: 1.4; margin-bottom: 3px; }
        .al-notif-time { font-size: 0.68rem; color: ${t.textMuted}; }

        .al-profile-btn {
          display: flex; align-items: center; gap: 9px;
          padding: 3px 8px 3px 3px;
          border-radius: 10px;
          border: 1px solid ${t.border};
          background: ${t.bgCard};
          cursor: pointer;
          transition: background 0.18s, border-color 0.18s;
          flex-shrink: 0;
        }
        .al-profile-btn:hover {
          background: ${t.bgHover};
          border-color: ${t.borderActive};
        }

        .al-avatar {
          width: 30px; height: 30px; border-radius: 8px;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          display: flex; align-items: center; justify-content: center;
          font-size: 0.72rem; font-weight: 700; color: #fff; flex-shrink: 0;
        }

        .al-profile-name { font-size: 0.78rem; font-weight: 600; color: ${t.textPrimary}; line-height: 1.2; white-space: nowrap; }
        .al-profile-role { font-size: 0.66rem; color: ${t.textMuted}; }

        .al-profile-item {
          display: flex; align-items: center; gap: 10px;
          padding: 10px 16px;
          font-size: 0.8rem; color: ${t.textSecondary};
          cursor: pointer;
          transition: background 0.15s, color 0.15s;
        }
        .al-profile-item:hover { background: ${t.bgHover}; color: ${t.textPrimary}; }
        .al-profile-item.danger { color: #ef4444; }
        .al-profile-item.danger:hover { background: #fef2f2; color: #dc2626; }

        /* ══════════════════════════════════════
           PAGE CONTENT
        ══════════════════════════════════════ */
        .al-content {
          margin-left: ${SW};
          margin-top: ${TH};
          min-height: calc(100vh - ${TH});
          padding: 26px;
          transition: margin-left 0.32s cubic-bezier(.22,1,.36,1);
        }

        /* ══════════════════════════════════════
           MOBILE
        ══════════════════════════════════════ */
        .al-mob-overlay {
          display: none;
          position: fixed; inset: 0;
          background: rgba(2,11,26,0.7);
          z-index: 150;
          backdrop-filter: blur(4px);
        }
        .al-mob-btn {
          display: none;
          width: 37px; height: 37px;
          border-radius: 9px;
          border: 1px solid ${t.border};
          background: ${t.bgCard};
          align-items: center; justify-content: center;
          cursor: pointer; color: ${t.textSecondary}; flex-shrink: 0;
        }

        @media (max-width: 768px) {
          .al-sidebar {
            left: ${mobileOpen ? "0" : "-260px"} !important;
            width: 240px !important;
          }
          .al-topbar { left: 0 !important; }
          .al-content { margin-left: 0 !important; }
          .al-mob-overlay { display: ${mobileOpen ? "block" : "none"}; }
          .al-mob-btn { display: flex; }
          .al-search { display: none; }
          .al-collapse-btn { display: none; }
          .al-nav-label { opacity: 1 !important; }
          .al-section-label { opacity: 1 !important; max-height: 30px !important; }
          .al-logo-text { opacity: 1 !important; }
        }

        /* ══════════════════════════════════════
           DEMO CONTENT
        ══════════════════════════════════════ */
        .al-demo-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
          gap: 14px;
          margin-bottom: 22px;
        }
        .al-stat-card {
          background: ${t.bgCard};
          border: 1px solid ${t.border};
          border-radius: 16px;
          padding: 20px;
          transition: border-color 0.2s, box-shadow 0.2s;
          ${t.glass ? "backdrop-filter: blur(12px);" : ""}
        }
        .al-stat-card:hover {
          border-color: ${t.borderActive};
          box-shadow: ${dark ? "0 4px 20px rgba(0,100,255,0.1)" : "0 4px 16px rgba(0,68,238,0.08)"};
        }
        .al-stat-label {
          font-size: 0.7rem; font-weight: 600;
          letter-spacing: 0.08em; text-transform: uppercase;
          color: ${t.textMuted}; margin-bottom: 10px;
        }
        .al-stat-value {
          font-size: 1.7rem; font-weight: 700;
          color: ${t.textPrimary}; letter-spacing: -0.03em;
          line-height: 1; margin-bottom: 6px;
        }
        .al-stat-change { font-size: 0.72rem; font-weight: 500; color: #22c55e; }

        .al-page-heading { font-size: 1.25rem; font-weight: 700; color: ${t.textPrimary}; margin-bottom: 3px; letter-spacing: -0.02em; }
        .al-page-sub { font-size: 0.8rem; color: ${t.textMuted}; margin-bottom: 22px; }

        .al-card {
          background: ${t.bgCard};
          border: 1px solid ${t.border};
          border-radius: 16px;
          padding: 22px;
          ${t.glass ? "backdrop-filter: blur(12px);" : ""}
        }
      `}</style>

      {/* Mobile overlay */}
      <div className="al-mob-overlay" onClick={() => setMobileOpen(false)} />

      {/* ══ SIDEBAR ══ */}
      <aside className="al-sidebar">
        {/* Logo */}
        <div className="al-logo-row">
          <div className="al-logo-mark">
            <img
              src={escudo}
              alt="Escudo"
              style={{ width: 17, height: 17, objectFit: "contain" }}
            />
          </div>
          {!collapsed && <span className="al-logo-text">Tech Next</span>}
          <div className="al-collapse-btn" onClick={() => setCollapsed(c => !c)} title={collapsed ? "Expandir" : "Colapsar"}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </div>
        </div>

        {/* Nav */}
        <nav className="al-nav">
          {NAV_ITEMS.map(({ section, items }) => (
            <div className="al-nav-section" key={section}>
              <div className="al-section-label">{section}</div>
              {items.map(item => {
                const hasChildren = !!item.children;
                const isChildActive = hasChildren && item.children.some(c => c.id === activeItem);
                const isOpen = hasChildren && expandedNav === item.id;

                return (
                  <div key={item.id}>
                    <div
                      className={`al-nav-item ${(!hasChildren && activeItem === item.id) ? "active" : ""}`}
                      onClick={() => handleNavClick(item)}
                      data-tip={item.label}
                    >
                      <span className="al-nav-icon"><NavIcon name={item.icon} /></span>
                      <span className="al-nav-label">{item.label}</span>
                      {hasChildren && (
                        <span className={`al-nav-caret ${isOpen ? "open" : ""}`}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 6 15 12 9 18" />
                          </svg>
                        </span>
                      )}
                    </div>

                    {hasChildren && isOpen && !collapsed && (
                      <div className="al-nav-children">
                        {item.children.map(child => (
                          <div
                            key={child.id}
                            className={`al-nav-child ${activeItem === child.id ? "active" : ""}`}
                            onClick={() => { setActiveItem(child.id); setMobileOpen(false); }}
                          >
                            {child.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </nav>

        {/* Bottom — theme toggle */}
        <div className="al-sidebar-bottom">
          <div className="al-theme-row" onClick={toggleDark}>
            <span className="al-nav-icon">
              {dark ? <MoonIcon /> : <SunIcon />}
            </span>
            {!collapsed && (
              <>
                <span style={{ flex: 1 }}>{dark ? "Modo Escuro" : "Modo Claro"}</span>
                <div className="al-switch" />
              </>
            )}
          </div>
        </div>
      </aside>

      {/* ══ TOPBAR ══ */}
      <header className="al-topbar">
        {/* Mobile menu */}
        <div className="al-mob-btn" onClick={() => setMobileOpen(o => !o)}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </div>

        {/* Título da página + breadcrumb */}
        <div className="al-page-title-bar">

        </div>

        {/* Actions */}
        <div className="al-actions">

          {/* Perfil */}
          <div style={{ position: "relative" }} ref={profileRef}>
            <div className="al-profile-btn" onClick={() => { setShowProfile(s => !s); setShowNotif(false); }}>
              <div className="al-avatar">JS</div>
              <div>
                <div className="al-profile-name">{nome}</div>
                <div className="al-profile-role">{perfil}</div>
              </div>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" style={{ color: t.textMuted }}>
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>

            {showProfile && (
              <div className="al-dropdown" style={{ minWidth: "200px" }}>
                <div className="al-drop-header">A minha conta</div>
                <div className="al-profile-item danger" style={{ borderTop: `1px solid ${t.border}` }}
                  onClick={handleLogout}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  Terminar sessão
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* ══ CONTEÚDO ══ */}
      <main className="al-content">
        {children ?? renderContent()}
      </main>
    </>
  );
}

// ── Demo ───────────────────────────────────────────────────────────────────
function DemoContent({ t, dark, label }) {
  return (
    <>
      <div className="al-card">
        <p style={{ fontSize: "0.84rem", color: t.textMuted, lineHeight: 1.7 }}>
          Conteúdo de <strong style={{ color: t.textPrimary }}>{label}</strong> aparece aqui.
          Passa o teu componente como <code style={{ background: t.bgHover, padding: "2px 6px", borderRadius: 5, fontSize: "0.78rem" }}>children</code> ao <code style={{ background: t.bgHover, padding: "2px 6px", borderRadius: 5, fontSize: "0.78rem" }}>AppLayout</code>.
        </p>
      </div>
    </>
  );
}

// ── Ícones ─────────────────────────────────────────────────────────────────
function NavIcon({ name }) {
  const icons = {
    grid: <><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></>,
    chart: <><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></>,
    pos: <><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></>,
    invoice: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></>,
    hr: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
    clock: <><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>,
    users: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" /></>,
  };
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {icons[name]}
    </svg>
  );
}
function MoonIcon() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>;
}
function SunIcon() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" /></svg>;
}